import Api from "./api";
import GlobalStrorage from '../global/GlobalStrorage';
export default {
  userAthenticate(loginid, password) {
   
    let apiurl = "userlogin/?format=json&loginid=" + loginid + "&password=" + password + "";
    ////alert(apiurl);
    return Api.get(apiurl);
  },
  userExtraAthenticate(user_id, key, app_id) {
    let apiurl = "applogin/?user_id="+user_id+"&key="+key+"&app_id="+app_id+"";
    
    return Api.get(apiurl);
  },
  getloginuserapps(userid) {
    let apiurl = "user_app_url/?user_id="+userid;
    return Api.get(apiurl);
  },
  getselectedproject() {
    // localStorage.setItem("Parm_Project",15);
    //return localStorage.getItem("Parm_Project"); 
    return GlobalStrorage.getProjectID();
  },

  validateAction(parm_step) {
    let tempcurrentstep = GlobalStrorage.getcurrentstep();
    if (tempcurrentstep < parm_step) {
      //alert("sorry");
      this.$router.push('/dashboard');
    }
  },
  gettheParameterByProjectStep(varstep) {
    let varproject = this.getselectedproject();
    let apiurl = "save_project_details/?project=" + varproject + "&step=" + varstep;
    ////alert(apiurl);
    return Api.get(apiurl);
  },
  getthemaxstep() {
    let varproject = this.getselectedproject();
    let apiurl = "laststep_byproject/?project=" + varproject;
    
    return Api.get(apiurl);
  },
  api_get_project_region_list() {

    let apiurl = "get_project_region_list/?project=" + this.getselectedproject();
    //let apiurl = "apply_adstock_varlist/?";
    
    return Api.get(apiurl);
  },
  api_get_project_variable_list()
    {
      
        let apiurl = "get_project_variable_list/?project="+this.getselectedproject();
        //let apiurl = "apply_adstock_varlist/?";
        
        return Api.get(apiurl);
    },

    //save staep data
    api_save_step1()
    {
      
        let apiurl = "save_step1/?project="+this.getselectedproject();
        //let apiurl = "apply_adstock_varlist/?";
        
        return Api.get(apiurl);
    },
    api_save_step2()
    {
      
        let apiurl = "save_step2/?project="+this.getselectedproject();
        //let apiurl = "apply_adstock_varlist/?";
        
        return Api.get(apiurl);
    },
    api_save_step3()
    {
      
        let apiurl = "save_step3/?project="+this.getselectedproject();
        //let apiurl = "apply_adstock_varlist/?";
        //alert(apiurl);
        return Api.get(apiurl);
    },
    api_save_step4()
    {
      
        let apiurl = "save_step4/?project="+this.getselectedproject();
        //let apiurl = "apply_adstock_varlist/?";
        //alert(apiurl);
        return Api.get(apiurl);
    },
    api_save_step5() {

      let apiurl = "save_step5/?project=" + this.getselectedproject();
      //let apiurl = "apply_adstock_varlist/?";
      //alert(apiurl);
      return Api.get(apiurl);
    },

    //getstepdata
    api_get_project_data_instep1() {
      let apiurl = "get_project_data/?project=" + this.getselectedproject() + "&step=1";
      //alert(apiurl);
      return Api.get(apiurl);
    },

    //save default values of steps

    
    api_save_project_details_step3() {
      let apiurl = "save_project_details/?project=" + this.getselectedproject() + "&step=3&trend=0&season=0&decay=0";
      //alert(apiurl);
      return Api.get(apiurl);
    },
    
    


}